export default __webpack_public_path__ + "static/media/signup-arrow-hover.1800de31.svg";